// utils/parseScenarios.js  (or inline wherever files are added)
import * as XLSX from "xlsx";
export async function parseScenariosFromFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

        if (!rows.length) return resolve([1]);

        // Find all columns named "State List 1", "State List 2", etc.
        const scenarioNumbers = Object.keys(rows[0])
          .map((k) => {
            const match = k.match(/^State List\s+(\d+)$/);
            return match ? Number(match[1]) : null;
          })
          .filter((n) => n !== null)
          .sort((a, b) => a - b);

        resolve(scenarioNumbers.length ? scenarioNumbers : [1]);
      } catch {
        resolve([1]);
      }
    };
    reader.readAsArrayBuffer(file);
  });
}